import { fromJS } from 'immutable/dist/immutable';
import { fieldToNumber, fieldTrimmed, normalizeInitialFormValues } from '../../../../../form/formUtilities';

export const createInitialForm = volcanoLoc => fromJS({
  id: normalizeInitialFormValues(volcanoLoc, ['id']),
  num: normalizeInitialFormValues(volcanoLoc, ['num']),
  newNum: normalizeInitialFormValues(volcanoLoc, ['newNum']),
  name: normalizeInitialFormValues(volcanoLoc, ['name']),
  country: normalizeInitialFormValues(volcanoLoc, ['country']),
  region: normalizeInitialFormValues(volcanoLoc, ['region']),
  latitude: normalizeInitialFormValues(volcanoLoc, ['latitude']),
  longitude: normalizeInitialFormValues(volcanoLoc, ['longitude']),
  elevation: normalizeInitialFormValues(volcanoLoc, ['elevation']),
  morphology: normalizeInitialFormValues(volcanoLoc, ['morphology']),
  status: normalizeInitialFormValues(volcanoLoc, ['status']),
  timeErupt: normalizeInitialFormValues(volcanoLoc, ['timeErupt']),
  location: normalizeInitialFormValues(volcanoLoc, ['location']),
  objectId: normalizeInitialFormValues(volcanoLoc, ['objectId']),
});

export const volcanoLocationEditModel = fromJS({
  name: 'volcanoLocationEditForm',
  initialValues: createInitialForm(),
});

export const formToJson = form => ({
  id: fieldToNumber(form.get('id')),
  num: fieldTrimmed(form.get('num')),
  newNum: fieldToNumber(form.get('newNum')),
  name: fieldTrimmed(form.get('name')),
  country: fieldTrimmed(form.get('country')),
  region: fieldTrimmed(form.get('region')),
  latitude: fieldToNumber(form.get('latitude')),
  longitude: fieldToNumber(form.get('longitude')),
  elevation: fieldToNumber(form.get('elevation')),
  morphology: fieldTrimmed(form.get('morphology')),
  status: fieldTrimmed(form.get('status')),
  timeErupt: fieldTrimmed(form.get('timeErupt')),
  location: fieldTrimmed(form.get('location')),
  objectId: fieldToNumber(form.get('objectId')),
});
